// Modal event handlers

if ( $('.close-modal').length ) {
	$('.close-modal').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.modal').removeClass('show-modal');
	});
}

if ( $('.show-modal[data-modal]').length ) {
	$('.show-modal[data-modal]').on('click', function() {
		var $modal = $('.' + $(this).data('modal')).first();

		if ( !$modal.length ) {
			return false;
		} else {
			$modal.addClass('show-modal');
		}
	});
}

if ( $('.modal').length ) {
	$('html').on('keyup', function(e) {
		if ( e.originalEvent.keyCode === 27 ) {
			$('.modal').removeClass('show-modal');
		}
	});

	$('.modal').on('click', function(e) {
		if ( e.target === e.currentTarget ) {
			$(this).removeClass('show-modal');
		}
	});
}
